import Vuex from 'vuex'

// 换乘的store
export default new Vuex.Store({
  //定义状态
  state: {
   LineClassDayGID: ''
  },
  getters: {
    getLineClassDayGID(state) {
      return state.LineClassDayGID
    }
  },
  //更改状态信息
  mutations: {
    newLineClassDayGID(state, LineClassDayGID) {
      state.LineClassDayGID = LineClassDayGID
    }
  },
  //应用mutation
  actions: {
    getNewLineClassDayGID(context, LineClassDayGID) {
      context.commit('newLineClassDayGID', LineClassDayGID)
    }
  }
})
